import { Link, useLocation, Outlet } from "react-router-dom";
import { LayoutDashboard, FileText, Package, Calendar, Users, DollarSign, LogOut, Moon, Sun, Settings, FilePlus } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useTheme } from "@/contexts/ThemeContext";
import { useNavigate } from "react-router-dom";

const navItems = [
  { path: "/admin", icon: LayoutDashboard, label: "Dashboard", exact: true },
  { path: "/admin/nueva-cotizacion", icon: FilePlus, label: "Nueva Cotización" },
  { path: "/admin/cotizaciones", icon: FileText, label: "Cotizaciones" },
  { path: "/admin/produccion", icon: Package, label: "Producción" },
  { path: "/admin/calendario", icon: Calendar, label: "Calendario" },
  { path: "/admin/clientes", icon: Users, label: "Clientes" },
  { path: "/admin/precios", icon: DollarSign, label: "Precios" },
  { path: "/admin/configuracion", icon: Settings, label: "Sitio Web" },
];

export default function AdminLayout() {
  const location = useLocation();
  const { user, logout } = useAuth();
  const { dark, toggle } = useTheme();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="flex h-screen bg-[var(--pym-bg-dash)]" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-56 bg-[#0F172A] text-white flex flex-col shrink-0" data-testid="admin-sidebar">
        <div className="p-4 border-b border-white/10">
          <Link to="/" className="flex items-center gap-2">
            <img src="https://customer-assets.emergentagent.com/job_promo-quote/artifacts/wgwlu5pd_WhatsApp%20Image%202026-03-27%20at%2018.43.52.jpeg" alt="PYM" className="h-8 w-auto" />
          </Link>
        </div>
        <nav className="flex-1 py-4 px-2 space-y-1">
          {navItems.map(({ path, icon: Icon, label, exact }) => {
            const active = exact ? location.pathname === path : location.pathname.startsWith(path);
            return (
              <Link
                key={path}
                to={path}
                data-testid={`admin-nav-${label.toLowerCase()}`}
                className={`flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium transition-colors ${active ? "bg-[#0047AB] text-white" : "text-[#94A3B8] hover:text-white hover:bg-white/5"}`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </Link>
            );
          })}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="text-xs text-[#94A3B8] mb-2 px-2 truncate">{user?.email}</div>
          <button onClick={toggle} className="flex items-center gap-2 px-3 py-2 text-sm text-[#94A3B8] hover:text-white hover:bg-white/5 rounded-sm w-full transition-colors mb-1" data-testid="admin-theme-toggle">
            {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />} {dark ? "Modo Claro" : "Modo Oscuro"}
          </button>
          <button onClick={handleLogout} className="flex items-center gap-2 px-3 py-2 text-sm text-[#94A3B8] hover:text-white hover:bg-white/5 rounded-sm w-full transition-colors" data-testid="admin-logout-btn">
            <LogOut className="w-4 h-4" /> Cerrar Sesión
          </button>
        </div>
      </aside>
      {/* Main */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
